import { render, staticRenderFns } from "./BarSettings.vue?vue&type=template&id=3e40e968&scoped=true&"
import script from "./BarSettings.vue?vue&type=script&lang=js&"
export * from "./BarSettings.vue?vue&type=script&lang=js&"
import style0 from "./BarSettings.vue?vue&type=style&index=0&id=3e40e968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40e968",
  null
  
)

export default component.exports